<template>
  <div>
    <template v-if="isLoading">
      <v-row justify="center" align="center">
        <v-col cols="4" class="d-flex justify-center">
          <v-progress-circular
            indeterminate
            color="primary"
            size="50"
          ></v-progress-circular>
        </v-col>
      </v-row>
    </template>

    <template v-else-if="qrCodeUrl">
      <ui-box class="mt-4" border-color="rgba(0, 0, 0, 0.38)">
        <v-row>
          <v-col>
            <div class="v-text-field__details">
              <div class="v-messages theme--light" role="alert">
                <div class="v-messages__wrapper">
                  <div class="v-messages__message message-transition-enter-to">
                    <div class="mb-1" style="font-size: 12px;">
                      <span class="black--text">QR Code</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <div class="d-flex">
              <div
                class="me-4 position-relative"
                :style="{
                  maxWidth: `${qrCodeImageSize}px`,
                  width: 'calc(50% - 1rem)'
                }"
              >
                <v-img
                  :aspect-ratio="1"
                  class="rounded-lg"
                  :src="qrCodeUrl"
                ></v-img>
                <div
                  class="align-center d-flex justify-space-between mt-2 grey lighten-4 rounded-lg px-2 py-1"
                >
                  <div class="text-caption">
                    {{ $vuetify.breakpoint.xsOnly ? 'Download' : 'Download QR Code' }}
                  </div>
                  <div class="d-flex">
                    <v-btn
                      aria-label="Download QR Code"
                      class="rounded"
                      color="secondary"
                      depressed
                      :download="downloadFileName"
                      :href="qrCodeUrl"
                      icon
                      small
                      tag="a"
                    >
                      <v-icon size="20">mdi-download</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
              <div
                class="ms-4"
                :style="{
                  minWidth: 'calc(50% - 1rem)',
                  width: `calc(100% - min(${qrCodeImageSize}px, calc(50% - 1rem)) - 1rem)`
                }"
              >
                <h6>What is this?</h6>
                This QR Code should be downloaded and printed for
                display at <span class="font-weight-medium">{{ placeName }}</span> for pass holders to scan and check-in.
              </div>
            </div>
          </v-col>
        </v-row>
      </ui-box>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import { kebabCase } from 'lodash';

export default {
  name: 'QrCodeLoader',
  props: {
    partnerId: {
      type: [String, Number],
      required: true
    },
    placeId: {
      type: [String, Number],
      required: true
    },
    placeName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      qrCodeUrl: null
    };
  },
  computed: {
    downloadFileName() {
      return `${this.kebabCase(this.placeName)}-qr-code.png`;
    },
		qrCodeImageSize() {
			return this.$vuetify.breakpoint.smAndUp ? 180 : 240;
		}
  },
  methods: {
		kebabCase,
    fetchQrCode() {
      this.isLoading = true;
      const url = `/partner-portal/${this.partnerId}/passes/get-qr-code/${this.placeId}`;
      
      axios.get(url)
        .then(response => {
          this.qrCodeUrl = response.data.data.checkInQrCodeImageUrl;
          this.$emit('loaded', this.qrCodeUrl);
        })
        .catch(error => {
          this.$emit('error', error);
          window.EventBus.$emit(
            'system-messages',
            [{ message: error.message, messageType: 'error' }]
          );
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  watch: {
    placeId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.fetchQrCode();
        }
      }
    }
  }
};
</script>
